"use client";

import { c as _c } from "react/compiler-runtime";
import { useChains } from "@opensea/app-kit";
import { useCurrency } from "@opensea/navigation";
import { Avatar } from "@opensea/next-ui-kit";
import { classNames, TextBody, TextBodySkeleton } from "@opensea/ui-kit";
import { useChainIdentifier, useViewWalletFlow } from "@opensea/wallet";
import { useTranslations } from "next-intl";
import { ConnectButton } from "@/components/connect/ConnectButton";
import { AccountBalance } from "./AccountBalance";
import { useTopNavbarSkeletonClassNames } from "./hooks";
const connectButtonClassNames = classNames("gap-2 px-4");
export function TopNavConnectButton(t0) {
  const $ = _c(20);
  const {
    className,
    address
  } = t0;
  const {
    currency
  } = useCurrency();
  const chainIdentifier = useChainIdentifier();
  const viewWalletFlow = useViewWalletFlow();
  const {
    getLogo
  } = useChains();
  const t = useTranslations("TopNavConnectButton");
  let t1;
  if ($[0] !== chainIdentifier || $[1] !== currency || $[2] !== getLogo) {
    t1 = chainIdentifier && currency === "crypto" ? <Avatar size={16} {...getLogo(chainIdentifier)} /> : null;
    $[0] = chainIdentifier;
    $[1] = currency;
    $[2] = getLogo;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <TextBody weight="regular"><AccountBalance /></TextBody>;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1) {
    t3 = <>{t1}{t2}</>;
    $[5] = t1;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const connectedChildren = t3;
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <TopNavConnectButtonSkeleton />;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const skeletonFallback = t4;
  let t5;
  if ($[8] !== className) {
    t5 = classNames(connectButtonClassNames, className);
    $[8] = className;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== address || $[11] !== viewWalletFlow) {
    t6 = connectedAddress => {
      viewWalletFlow(address || connectedAddress);
    };
    $[10] = address;
    $[11] = viewWalletFlow;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t) {
    t7 = t("connectWallet");
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== connectedChildren || $[16] !== t5 || $[17] !== t6 || $[18] !== t7) {
    t8 = <ConnectButton className={t5} connectedChildren={connectedChildren} onConnectedClick={t6} skeletonFallback={skeletonFallback} variant="ghost">{t7}</ConnectButton>;
    $[15] = connectedChildren;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
}
function TopNavConnectButtonSkeleton() {
  const $ = _c(4);
  const skeletonClassNames = useTopNavbarSkeletonClassNames();
  let t0;
  if ($[0] !== skeletonClassNames) {
    t0 = classNames("mx-4 w-[100px]", skeletonClassNames);
    $[0] = skeletonClassNames;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <TextBodySkeleton className={t0} />;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}